<template>
  <div>
    <slot></slot>
    <div v-if="focus && focus.state == 'ontrack'">
      <div style="display: flex">
        <div>
          <div>
            <button @click="handleClickCheckin(tool)">
              Check
            </button>
            <div v-if="checkInAt">Checked In At {{ checkInAt }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="focus && focus.state == 'ondeck'">
      <div style="display: flex">
        <div>
          Settings:
          <hr />
          <p>Use QR Code</p>
        </div>
      </div>
    </div>

    <div v-else-if="focus && focus.state == 'stationed'">
      <div style="display: flex">
        STATIONED
      </div>
    </div>

    <div v-else>
      <div style="display: flex">
        <div>
          SPLASH: INVALID STATE
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "checkin-web-component",
  components: {},
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: String,
      required: false,
      default: () => ""
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    }
  },
  methods: {
    handleClickCheckin(tool) {
      let updatedTool;
      this.checkInAt = new Date();
      if (tool.tracks) {
        updatedTool = {
          ...tool,
          tracks: [
            ...tool.tracks,
            {
              _created_at: this.checkInAt
            }
          ]
        };
      } else {
        updatedTool = { ...tool, tracks: [{ _created_at: this.checkInAt }] };
      }
      // this.$store.dispatch('tools/setTrackerInTool', {focusId: this.focus.focusId, userUid: this.$store.getters['user/user'].uid, tool: updatedTool })
      this.setTracker({
        focusId: this.focus.focusId,
        userUid: this.user,
        tool: updatedTool
      });
    }
  },
  computed: {},
  data: function() {
    return {
      showTracking: false,
      checkInAt: null
    };
  },
  mounted() {}
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.notepad {
  background-color: rgb(255, 242, 204);
  border-radius: 5px;
  width: 100%;
  height: 125px;
}
.card-body {
  overflow-y: auto;
}
</style>
